// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import {
    BlogCategoryArticlesCollectionModel,
    BlogMostRecentCollectionModel,
    BlogSimilarArticlesCollectionModel,
} from "@store/Framework/Types/ApiModels";

const blogUrl = "/api/v2/blog";

export interface GetBlogBaseApiParameter extends ApiParameter {
    nodeId: string;
    cacheInvalidationId?: string;
}

export interface GetBlogMostRecentApiParameter extends GetBlogBaseApiParameter {
    quantity?: number;
}

export interface GetBlogCategoryArticlesApiParameter extends GetBlogBaseApiParameter, HasPagingParameters {}

export interface GetBlogCategoryFeaturedArticleApiParameter extends ApiParameter {
    pageLink: string;
}

export interface GetBlogSimilarArticlesApiParameter extends GetBlogBaseApiParameter {
    quantity?: number;
}

export const getBlogMostRecent = async (parameter: GetBlogMostRecentApiParameter) => {
    let articles: BlogMostRecentCollectionModel = {
        pages: [],
        uri: "",
        properties: {},
    };
    const { nodeId, ...apiParameter } = parameter;

    try {
        articles = await get<BlogMostRecentCollectionModel>(`${blogUrl}/${nodeId}/articles/recent`, apiParameter);
    } catch (error) {
        logger.warn(`Failed to load Blog Most Recent Collection: ${error.errorMessage}`);
    }

    return articles;
};

export const getBlogCategoryArticles = async (parameter: GetBlogCategoryArticlesApiParameter) => {
    let articles: BlogCategoryArticlesCollectionModel = {
        pages: [],
        pagination: {} as any,
        uri: "",
        properties: {},
    };
    const { nodeId, ...apiParameter } = parameter;

    try {
        articles = await get<BlogCategoryArticlesCollectionModel>(
            `${blogUrl}/categories/${nodeId}/articles`,
            apiParameter,
        );
    } catch (error) {
        logger.warn(`Failed to load Blog Category Articles Collection: ${error.errorMessage}`);
    }

    return articles;
};

export const getBlogSimilarArticles = async (parameter: GetBlogSimilarArticlesApiParameter) => {
    let articles: BlogSimilarArticlesCollectionModel = {
        pages: [],
        uri: "",
        properties: {},
    };
    const { nodeId, ...apiParameter } = parameter;

    try {
        articles = await get<BlogSimilarArticlesCollectionModel>(`${blogUrl}/articles/${nodeId}/similar`, apiParameter);
    } catch (error) {
        logger.warn(`Failed to load Blog Similar Articles Collection: ${error.errorMessage}`);
    }

    return articles;
};
